const PostPermissions = {
  edit: 'post:edit',
  create: 'post:create',
  delete: 'post:delete',
  view: 'post:view',
}

export default PostPermissions
